export const TEST_ID = 'pointModeDropdown';
